import styled from 'styled-components';

export const SectionTitle = styled.div`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
	margin-bottom: 12px;
`;

export const OrganizationList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-bottom: 16px;
	max-height: 300px;
	overflow-y: auto;
	padding-right: 8px;

	&::-webkit-scrollbar {
		width: 8px;
	}

	&::-webkit-scrollbar-track {
		background: ${({ theme }) => theme.gray[100]};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb {
		background: ${({ theme }) => theme.gray[400]};
		border-radius: 4px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: ${({ theme }) => theme.gray[600]};
	}
`;

export const OrganizationItem = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	padding: 8px 12px;
	background-color: ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-shrink: 0;
	height: 40px;
	box-sizing: border-box;
`;

export const OrganizationName = styled.span`
	font-weight: 500;
`;

export const AddButton = styled.button<{ disabled?: boolean }>`
	background-color: ${({ theme }) => theme.gray[400]};
	color: ${({ theme }) => theme.gray[1000]};
	border: none;
	border-radius: 4px;
	font-size: 13px;
	transition: background-color 0.2s;
	width: 60px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;

	&:hover {
		background-color: ${({ theme, disabled }) => (disabled ? theme.gray[400] : theme.gray[600])};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const RemoveButton = styled.button<{ disabled?: boolean }>`
	background-color: transparent;
	color: ${({ theme }) => theme.red[500]};
	border: none;
	border-radius: 4px;
	padding: 0px;
	font-size: 13px;
	width: 60px;
	height: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: 500;
	user-select: none;

	&:hover {
		background-color: ${({ theme, disabled }) => (disabled ? 'transparent' : theme.gray[100])};
	}

	&:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}
`;

export const LoadingContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	padding: 24px;
`;

export const LoadingText = styled.p`
	font-size: 14px;
	color: ${({ theme }) => theme.gray[1000]};
`;

export const Divider = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.gray[200]};
	margin-top: 8px;
	margin-bottom: 16px;
`;

export const EmptyState = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	padding: 12px;
	text-align: center;
`;
